<template>
  <PagesOnlineExhibitionsSlugComponent
    :pageData="data"
  />
</template>

<script setup>
useHead(({
  htmlAttrs: { 'data-page': 'online-exhibition' },
}))

const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryOnlineExhibitionEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute()) } }
  )
})

if (!data?.value?.data?.length || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
